import React from 'react';

import type { Atoms } from '@rtkwlf/fenrir-react';
import { atoms, HStack, Text } from '@rtkwlf/fenrir-react';

import { Tooltip } from 'ae-components/tooltip/tooltip';

type LongTextTooltipProps = {
  truncateMaxWidth?: Atoms['maxWidth'];
  value: string;
};

export const LongTextTooltip = ({
  truncateMaxWidth = '8rem',
  value,
}: LongTextTooltipProps) => {
  if (!value) return null;

  return (
    <HStack alignItems="center">
      <Tooltip
        tooltip={value}
        tooltipContentProps={{
          maxWidth: 'prose',
          side: 'top',
        }}
      >
        <Text
          className={atoms({
            maxWidth: truncateMaxWidth,
          })}
          display="inline-block"
          styledAs="body3"
          truncate
        >
          {value}
        </Text>
      </Tooltip>
    </HStack>
  );
};
